import api from './api';

const PROSPECT_MASTER_BASE_URL = '/prospect-master';

const prospectMasterService = {
  // Get all prospects with pagination and search
  getAllProspects: async (params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.search) queryParams.append('search', params.search);
      if (params.category) queryParams.append('category', params.category);
      if (params.region) queryParams.append('region', params.region);
      if (params.stage) queryParams.append('stage', params.stage);
      if (params.status) queryParams.append('status', params.status);
      if (params.sortBy) queryParams.append('sortBy', params.sortBy);
      if (params.sortOrder) queryParams.append('sortOrder', params.sortOrder);

      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospects:', error);
      throw error;
    }
  },

  // Get prospect by ID
  getProspectById: async (id) => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospect:', error);
      throw error;
    }
  },

  // Create new prospect
  createProspect: async (prospectData) => {
    try {
      const response = await api.post(PROSPECT_MASTER_BASE_URL, prospectData);
      return response.data;
    } catch (error) {
      console.error('Error creating prospect:', error);
      throw error;
    }
  },

  // Update prospect
  updateProspect: async (id, prospectData) => {
    try {
      const response = await api.put(`${PROSPECT_MASTER_BASE_URL}/${id}`, prospectData);
      return response.data;
    } catch (error) {
      console.error('Error updating prospect:', error);
      throw error;
    }
  },

  // Delete prospect
  deleteProspect: async (id) => {
    try {
      const response = await api.delete(`${PROSPECT_MASTER_BASE_URL}/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting prospect:', error);
      throw error;
    }
  },

  // Get prospect statistics
  getProspectStats: async () => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/stats`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospect stats:', error);
      throw error;
    }
  },

  // Get active prospects
  getActiveProspects: async () => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/active`);
      return response.data;
    } catch (error) {
      console.error('Error fetching active prospects:', error);
      throw error;
    }
  },

  // Get prospects by category
  getProspectsByCategory: async (category) => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/category/${category}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospects by category:', error);
      throw error;
    }
  },

  // Get prospects by stage
  getProspectsByStage: async (stage) => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/stage/${stage}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospects by stage:', error);
      throw error;
    }
  },

  // Get prospects by region
  getProspectsByRegion: async (region) => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/region/${region}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching prospects by region:', error);
      throw error;
    }
  },

  // Download prospect upload template (Excel)
  downloadProspectTemplate: async () => {
    try {
      const response = await api.get(`${PROSPECT_MASTER_BASE_URL}/template`, {
        responseType: 'blob'
      });
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'prospect_upload_template.xlsx');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      return { success: true };
    } catch (error) {
      console.error('Error downloading prospect template:', error);
      throw error;
    }
  },

  // Upload prospects from Excel file
  uploadProspects: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      const response = await api.post(`${PROSPECT_MASTER_BASE_URL}/upload`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      return response.data;
    } catch (error) {
      console.error('Error uploading prospects:', error);
      throw error;
    }
  }
};

export default prospectMasterService;
